export default __webpack_public_path__ + "static/media/argon-react.128d71d3.png";